import qs from 'qs';
import axios from 'axios';

const ROOT_URL = 'http://api.masathena.com/api/v1'; //live
//const ROOT_URL = 'http://mas-athena.test.saberion.org/api/v1'; //test
//const ROOT_URL = 'http://mas-athena-reservation-cms.lh/api/v1'; //local
const KEY = 'base64:aRERSuhsOt3Wu7gzBV582z9ufaceH/mkFtxxv3vv94U=';
const SECRET = 'bKkKwh3mqanKygPgy8bNguGHGvGRS5HXvGeNGQZv8K5HgLhWae';
const querystring = {
    key: KEY,
    secret: SECRET
};

export default {
    async fetchEvents() {
        return axios.get(`${ROOT_URL}/event-categories?${qs.stringify(querystring)}`).then(response => {
            return response.data;
        });
    },
    async fetchConferences(event_id) {
        return axios.get(`${ROOT_URL}/event-category/${event_id}?${qs.stringify(querystring)}`).then(response => {
            return response.data;
        });
    },
    async getConference(conference_id) {
        return axios.get(`${ROOT_URL}/event/${conference_id}?${qs.stringify(querystring)}`).then(response => {
            return response.data;
        });
    },
    async postFirstStepBooking(data) {
        return axios.post(`${ROOT_URL}/bookings?${qs.stringify(querystring)}`, data, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(response => {
            return response.data;
        });
    },
    async fetchRooms(start_date, end_date) {
        return axios.get(`${ROOT_URL}/available-rooms/${start_date}/${end_date}?${qs.stringify(querystring)}`, {
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        }).then(response => {
            return response.data;
        });
    },
    async fetchRoom(room_id) {
        return axios.get(`${ROOT_URL}/rooms/${room_id}?${qs.stringify(querystring)}`).then(response => {
            return response.data;
        });
    },
    async postSecondStepBooking(data) {
        return axios.post(`${ROOT_URL}/book-rooms?${qs.stringify(querystring)}`, data, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(response => {
            return response.data;
        });
    },
    async fetchMeals() {
        return axios.get(`${ROOT_URL}/meal-plans?${qs.stringify(querystring)}`).then(response => {
            return response.data;
        });
    },
    async getMeal(meal_id) {
        return axios.get(`${ROOT_URL}/meal-plan/${meal_id}?${qs.stringify(querystring)}`).then(response => {
            return response.data;
        });
    },    
    async postThirdStepBooking(data) {
        return axios.post(`${ROOT_URL}/book-meal-plans?${qs.stringify(querystring)}`, data, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(response => {
            return response.data;
        });
    },
    async fetchActivities(category_id) {
        return axios.get(`${ROOT_URL}/activity-packages/${category_id}?${qs.stringify(querystring)}`).then(response => {
            return response.data;
        });
    },
    async getActivity(activity_id) {
        return axios.get(`${ROOT_URL}/activity-package/${activity_id}?${qs.stringify(querystring)}`).then(response => {
            return response.data;
        });
    },    
    async postFourthStepBooking(data) {
        return axios.post(`${ROOT_URL}/book-activity-packages?${qs.stringify(querystring)}`, data, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(response => {
            return response.data;
        });
    },
    async postFifthStepBooking(booking_id, data) {
        return axios.post(`${ROOT_URL}/bookings/${booking_id}?${qs.stringify(querystring)}`, data, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(response => {
            return response.data;
        });
    },
    async getCheckout(booking_id) {
        return axios.get(`${ROOT_URL}/bookings/${booking_id}?${qs.stringify(querystring)}`).then(response => {
            return response.data;
        });
    },
    async getRates() {
        return axios.get(`${ROOT_URL}/conversion-rates?${qs.stringify(querystring)}`).then(response => {
            return response.data;
        });
    },
    async fetchResources(start_date, end_date) {
        return axios.get(`${ROOT_URL}/available-centers/${start_date}/${end_date}?${qs.stringify(querystring)}`).then(response => {
            return response.data;
        });
    },
    async fetchResource(resource_id) {
        return axios.get(`${ROOT_URL}/center/${resource_id}?${qs.stringify(querystring)}`).then(response => {
            return response.data;
        });
    },    
    async createEvent(data) {
        return axios.post(`${ROOT_URL}/events?${qs.stringify(querystring)}`, data, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(response => {
            return response.data;
        });
    },
    async createEventSecondStep(event_id, data) {
        return axios.post(`${ROOT_URL}/event/${event_id}?${qs.stringify(querystring)}`, data, {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(response => {
            return response.data;
        });
    },    
    async getTax() {
        return axios.get(`${ROOT_URL}/tax?${qs.stringify(querystring)}`).then(response => {
            return response.data;
        });
    },
    async confirmBooking(booking_id, currency) {
        return axios.post(`${ROOT_URL}/confirm-booking/${booking_id}/${currency}?${qs.stringify(querystring)}`).then(response => {
            return response.data;
        });
    },
    async confirmEvent(event_id, currency) {
        return axios.post(`${ROOT_URL}/confirm-event/${event_id}/${currency}?${qs.stringify(querystring)}`).then(response => {
            return response.data;
        });
    }                                
};
 